import { GET_ALL_ORDERS, GET_ORDER_VIEW, NEW_NOTIFY_ORDER } from "../actions/orders.action";


const defaultState = {
    page: 1,
    rowsPage: 10,
    restaurantId: null,
    storeId: null,
    dateFrom: null,
    dateTo: null,
    state: null,
    name: null,
    aggregatorId: null,
    rows: [],
    nRows: 0,
    orderId: null,
    orderData: {},
};

const reducer = (state = defaultState, { type, payload }) => {
    switch (type){
        case GET_ALL_ORDERS: {
            const { page, rowsPage, restaurantId, storeId, dateFrom, dateTo, state: orderState, name, aggregatorId, rows, nRows } = payload;
            return { ...state, page, rowsPage, restaurantId, storeId, dateFrom, dateTo, state: orderState, name, aggregatorId, rows, nRows };
        }
        case GET_ORDER_VIEW: {
            const { orderId, orderData } = payload;
            return { ...state, orderId, orderData };
        }
        case NEW_NOTIFY_ORDER: {
            const exists = state.rows.some(row => row._id === payload._id);
            const rows = [
                { load: false, ...payload },
                ...state.rows.filter(row => row._id !== payload._id)
            ];
            return {
                ...state,
                rows,
                nRows: exists ? state.nRows : state.nRows + 1
            };
        }
        default: {
            return state;
        }
    }
};

export default reducer;